
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SimpleStepWizard extends Vue {
  @Prop({ required: true, type: Number }) readonly step!: number;

  get headers(): object {
    return Object.keys(this.$slots).filter((k) => k.startsWith('header'));
  }

  get steps(): object {
    return Object.keys(this.$slots).filter((k) => k.startsWith('step'));
  }
}
